import restaurant from './../../assets/images/static/restaurantIcon.png';
import pharmacy from './../../assets/images/static/pharmacyIcon.png';
import bakery from './../../assets/images/static/bakeryIcon.png';
import retail from './../../assets/images/static/retailIcon.png';

export const industry = [
  {
      id: 1,
      title: 'restaurant',
      src: restaurant,
  },
  {
      id: 2,
      title: 'pharmacy',
      src: pharmacy,
  },
  {
      id: 3,
      title: 'bakery',
      src: bakery,
  },
  {
      id: 4,
      title: 'retail',
      src: retail,
  },
]
